import { Badge } from '@pryme/ui';

const TEXT: Record<string, string> = {
  active: 'Active, issuer-verified person in the production trust environment.',
  active_sandbox: 'Active sandbox identity: an Idura MitID test user or an offline test-provider user. Never a real MitID-verified person.',
  pending_verification: 'Not an active verified identity (yet). Treat as unverified, never as a verified person.',
};

/** Surfaces the identity status vocabulary required by spec §14. */
export function IdentityStatusBadge(props: { status: 'active' | 'active_sandbox' | 'pending_verification' }) {
  const tone = props.status === 'active' ? 'ok' : props.status === 'active_sandbox' ? 'sandbox' : 'warn';
  return (
    <span className="p-row" style={{ gap: '0.4rem' }}>
      <Badge tone={tone}>identity: {props.status}</Badge>
      <span className="p-small p-muted">{TEXT[props.status]}</span>
    </span>
  );
}

export function IdentityStatusLegend() {
  return (
    <dl className="p-kv p-small">
      {Object.entries(TEXT).map(([k, v]) => (
        <div key={k} style={{ display: 'contents' }}>
          <dt><code>{k}</code></dt>
          <dd>{v}</dd>
        </div>
      ))}
    </dl>
  );
}
